import React from 'react'
// view components
import ApiTokensContainer from 'containers/ApiTokens'

const ApiTokensSettingsPage: React.FC = () => <ApiTokensContainer />

export default ApiTokensSettingsPage
